import { render, staticRenderFns } from "./treeDialog.vue?vue&type=template&id=d48f89e8"
import script from "./treeDialog.vue?vue&type=script&lang=js"
export * from "./treeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports